
import {
  Box,
  Text,
  VStack,
  Icon,
  Badge,
  HStack,
  Heading,
  useColorModeValue,
} from "@chakra-ui/react";

const LeaveStatusCard = ({ data }) => { 
  const cardBg = useColorModeValue("white", "gray.700");
  
  const getScheme = (status) => {
    switch (status.toLowerCase()) { 
      case "approved":
        return "green";
      case "pending":
        return "orange"; 
      case "declined":
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <Box
      p={6}
      bg={cardBg}
      boxShadow="md"
      borderWidth="1px"
      borderColor="gray.100"
      borderRadius="xs"
      width="100%"
      maxWidth="500px"
    >
      <Heading size="md" fontWeight="bold" mb={5} color="blue.600">
        Leave Status
      </Heading>

      <VStack spacing={3} align="stretch">
        {data && data.length > 0 ? (
          data.map((leave, index) => {
            const scheme = getScheme(leave.status);

            return (
              <Box
                key={index}
                p={4}
                borderRadius="lg"
                bg={`${scheme}.50`}
                // borderLeft={`5px solid var(--chakra-colors-${scheme}-500)`}
                transition="box-shadow 0.2s"
                _hover={{ boxShadow: "md" }}
              >
                <HStack justifyContent="space-between" mb={1}>
                  <HStack spacing={3}>
                    <Icon
                      as={leave.icon}
                      color={`${scheme}.600`}
                      boxSize={5}
                    />
                    <Text fontWeight="extrabold" fontSize="md" color="gray.800">
                      {leave.type}
                    </Text>
                  </HStack>
                  <Badge
                    colorScheme={scheme}
                    variant="subtle"
                    borderRadius="full"
                    px={3}
                    py={1}
                  >
                    {leave.status}
                  </Badge>
                </HStack>
                <Text fontSize="sm" color="gray.600" ml={8}>
                  {" "}
                  Date:{" "}
                  <Text as="span" fontWeight="semibold">
                    {leave.date}
                  </Text>
                </Text>
              </Box>
            );
          })
        ) : (
             <Text p={3} color="gray.500">No leave history available.</Text>
        )}
      </VStack>
    </Box>
  );
};

export default LeaveStatusCard;